import { BayLevelEnum, ForeAftEnum } from "open-vessel-definition";
import { cloneObject, feetToMillimeters, pad3, } from "@tedivo/tedivo-pure-helpers";
import { createRowsFromConfig } from "../createRowsFromConfig";
export function getContainersCgs(bayLcgVcgTcgAndPairings, containers) {
    const { minTierAbove, bayLevelPositionsDict, lcgsBy20Bay, missingImportantLcgs, missingImportantVcgs, missingImportantTcgs, sizeSummary: { centerLineRow, maxRow }, pairedBaysCalc: { pairedBaysPer20Bay }, } = bayLcgVcgTcgAndPairings;
    const containersCgsByPosition = {};
    const bayLevelCgsInfo = {};
    const containersCgsArray = [];
    const containerCgsByPairedBaysAndLevelAndRow = {};
    const contPositionsPushed = new Set();
    /** Create a dictionary per bay, level and row, and add other properties.
     * Contains an array of the containers in that bay-level-row.
     * Used to stack up containers heights */
    const containersByBayAndLevelAndRow = containers.reduce((acc, contInfo) => {
        const position = contInfo.position;
        const bay = position.substring(0, 3);
        const row = position.substring(3, 5);
        const tier = position.substring(5);
        const iBay = Number(bay);
        const level = Number(tier) >= minTierAbove ? BayLevelEnum.ABOVE : BayLevelEnum.BELOW;
        const positionKeys = contInfo.size < 40
            ? [
                // If it's on an odd bay we add it to one stack
                `${bay}-${level}-${row}`,
            ]
            : [
                // If it's on an even bay we add it to two stacks to find later in which it was declared
                `${pad3(iBay - 1)}-${level}-${row}`, // FWD declaration
                `${pad3(iBay + 1)}-${level}-${row}`, // AFT declaration
            ];
        positionKeys.forEach((posKey) => {
            if (!acc[posKey])
                acc[posKey] = [];
            const cBay = posKey.substring(0, 3);
            if (!contPositionsPushed.has(contInfo.position)) {
                acc[posKey].push(Object.assign(Object.assign({}, contInfo), { iBay: Number(cBay), bay: cBay, row,
                    tier,
                    level }));
                contPositionsPushed.add(contInfo.position);
            }
        });
        return acc;
    }, {});
    const baysAlreadyCalculated = new Set();
    const allRowsInShip = createRowsFromConfig(!!centerLineRow, maxRow);
    let shipMaxHeight = 0;
    Object.keys(pairedBaysPer20Bay).forEach((bayAndLevel) => {
        if (baysAlreadyCalculated.has(bayAndLevel))
            return;
        const [bay, levelStr] = bayAndLevel.split("-");
        const level = Number(levelStr);
        const pairedBay = pairedBaysPer20Bay[bayAndLevel];
        // baysAlreadyCalculated.add(bayAndLevel);
        // if (pairedBay) baysAlreadyCalculated.add(`${pairedBay}-${level}`);
        let maxHeight = 0;
        let portTcg = 0;
        let stbdTcg = 0;
        // Iterate over every row in the bay (up to the max row of the ship)
        allRowsInShip.forEach((row) => {
            const containersAtPairedRow = [
                ...(containersByBayAndLevelAndRow[`${bay}-${level}-${row}`] || []),
                // ...(pairedBay
                //   ? containersByBayAndLevelAndRow[`${pairedBay}-${level}-${row}`] || []
                //   : []),
            ];
            if (containersAtPairedRow.length === 0)
                return;
            // Sort containers in row from bottom -> top
            const contsInRowFromBottomToTop = containersAtPairedRow.sort(sortPositionByTierAsc);
            const oddBaysToDefine = new Set();
            // Iterate to add up (stack) the containers in the same row
            contsInRowFromBottomToTop.forEach((c) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                const slotPos = `${c.row}${c.tier}`;
                const iBay = c.iBay;
                // Look for the 20 in the BLP, or the 40 in the contiguous BLPs (-1 or +1)
                const isLessThan40ft = c.size < 40;
                let cellInfoBySize;
                if (isLessThan40ft) {
                    // Look up in the same bay definition
                    const blp = bayLevelPositionsDict[`${c.bay}-${level}`];
                    cellInfoBySize = (_b = (_a = blp === null || blp === void 0 ? void 0 : blp.getCellInfo(slotPos)) === null || _a === void 0 ? void 0 : _a.sizes) === null || _b === void 0 ? void 0 : _b.get(c.size);
                    if (cellInfoBySize) {
                        oddBaysToDefine.add(c.bay);
                        if (blp && portTcg > blp.minTcg)
                            portTcg = blp.minTcg;
                        if (blp && stbdTcg < blp.maxTcg)
                            stbdTcg = blp.maxTcg;
                    }
                }
                else {
                    if (iBay % 2 === 0) {
                        // Look up in the contiguous bays definitions
                        const blpFwd = bayLevelPositionsDict[`${pad3(iBay - 1)}-${level}`];
                        const blpAft = bayLevelPositionsDict[`${pad3(iBay + 1)}-${level}`];
                        // Look FWD
                        cellInfoBySize =
                            (blpFwd === null || blpFwd === void 0 ? void 0 : blpFwd.pairedBay) === ForeAftEnum.AFT
                                ? (_d = (_c = blpFwd === null || blpFwd === void 0 ? void 0 : blpFwd.getCellInfo(slotPos)) === null || _c === void 0 ? void 0 : _c.sizes) === null || _d === void 0 ? void 0 : _d.get(c.size)
                                : undefined;
                        // No? Look AFT
                        if (!cellInfoBySize) {
                            cellInfoBySize =
                                (blpAft === null || blpAft === void 0 ? void 0 : blpAft.pairedBay) === ForeAftEnum.FWD
                                    ? (_f = (_e = blpAft === null || blpAft === void 0 ? void 0 : blpAft.getCellInfo(slotPos)) === null || _e === void 0 ? void 0 : _e.sizes) === null || _f === void 0 ? void 0 : _f.get(c.size)
                                    : undefined;
                        }
                        if (blpFwd && cellInfoBySize) {
                            oddBaysToDefine.add(pad3(iBay - 1));
                            if (portTcg > blpFwd.minTcg)
                                portTcg = blpFwd.minTcg;
                            if (stbdTcg < blpFwd.maxTcg)
                                stbdTcg = blpFwd.maxTcg;
                        }
                        if (blpAft && cellInfoBySize) {
                            oddBaysToDefine.add(pad3(iBay + 1));
                            if (portTcg > blpAft.minTcg)
                                portTcg = blpAft.minTcg;
                            if (stbdTcg < blpAft.maxTcg)
                                stbdTcg = blpAft.maxTcg;
                        }
                    }
                    else {
                        const blpA = bayLevelPositionsDict[`${c.bay}-${level}`];
                        const blpB = blpA.pairedBay === ForeAftEnum.FWD
                            ? bayLevelPositionsDict[`${pad3(iBay - 2)}-${level}`]
                            : blpA.pairedBay === ForeAftEnum.AFT
                                ? bayLevelPositionsDict[`${pad3(iBay + 2)}-${level}`]
                                : undefined;
                        // Look Self
                        cellInfoBySize =
                            (blpA === null || blpA === void 0 ? void 0 : blpA.pairedBay) === ForeAftEnum.AFT
                                ? (_h = (_g = blpA === null || blpA === void 0 ? void 0 : blpA.getCellInfo(slotPos)) === null || _g === void 0 ? void 0 : _g.sizes) === null || _h === void 0 ? void 0 : _h.get(c.size)
                                : undefined;
                        // No? Look Paired
                        if (!cellInfoBySize && blpB) {
                            cellInfoBySize =
                                (blpB === null || blpB === void 0 ? void 0 : blpB.pairedBay) === ForeAftEnum.FWD
                                    ? (_k = (_j = blpB === null || blpB === void 0 ? void 0 : blpB.getCellInfo(slotPos)) === null || _j === void 0 ? void 0 : _j.sizes) === null || _k === void 0 ? void 0 : _k.get(c.size)
                                    : undefined;
                        }
                        if (blpA && cellInfoBySize) {
                            oddBaysToDefine.add(blpA.isoBay);
                            if (portTcg > blpA.minTcg)
                                portTcg = blpA.minTcg;
                            if (stbdTcg < blpA.maxTcg)
                                stbdTcg = blpA.maxTcg;
                        }
                        if (blpB && cellInfoBySize) {
                            oddBaysToDefine.add(blpB.isoBay);
                            if (portTcg > blpB.minTcg)
                                portTcg = blpB.minTcg;
                            if (stbdTcg < blpB.maxTcg)
                                stbdTcg = blpB.maxTcg;
                        }
                    }
                }
                if (!cellInfoBySize) {
                    return; // Cannot continue calculations
                }
                const clonedCellInfoBySize = cloneObject(cellInfoBySize);
                clonedCellInfoBySize.meta = cloneObject(c);
                if (missingImportantLcgs) {
                    clonedCellInfoBySize.lcg = bayLcgVcgTcgAndPairings.getMissing20Lcg(cellInfoBySize.isoOddBay, c.size);
                    if (clonedCellInfoBySize.lcg === undefined) {
                        const lcgT = bayLcgVcgTcgAndPairings.getMissing20Lcg(cellInfoBySize.isoOddBay, 20);
                        if (lcgT !== undefined && clonedCellInfoBySize.extending) {
                            const difSizeMiddle = feetToMillimeters((c.size - 20) * 0.5);
                            clonedCellInfoBySize.lcg =
                                clonedCellInfoBySize.extending === ForeAftEnum.FWD
                                    ? lcgT + difSizeMiddle
                                    : lcgT - difSizeMiddle;
                        }
                    }
                }
                if (missingImportantVcgs)
                    clonedCellInfoBySize.bottomBase =
                        bayLcgVcgTcgAndPairings.getMissingBottomBase(c.tier);
                if (missingImportantTcgs)
                    clonedCellInfoBySize.tcg = bayLcgVcgTcgAndPairings.getMissingTcg(c.row);
                if (clonedCellInfoBySize.bottomBase === undefined) {
                    return; // Cannot continue calculations
                }
                if (clonedCellInfoBySize.tcg !== undefined) {
                    if (portTcg > clonedCellInfoBySize.tcg)
                        portTcg = clonedCellInfoBySize.tcg;
                    if (stbdTcg < clonedCellInfoBySize.tcg)
                        stbdTcg = clonedCellInfoBySize.tcg;
                }
                // Save the container info by position
                oddBaysToDefine.forEach((oBay) => {
                    if (!containerCgsByPairedBaysAndLevelAndRow[`${oBay}-${level}-${row}`])
                        containerCgsByPairedBaysAndLevelAndRow[`${oBay}-${level}-${row}`] =
                            [];
                    containerCgsByPairedBaysAndLevelAndRow[`${oBay}-${level}-${row}`].push(clonedCellInfoBySize);
                });
                containersCgsByPosition[c.position] = clonedCellInfoBySize;
                containersCgsArray.push(clonedCellInfoBySize);
                // Save the bay level vcgs info
                oddBaysToDefine.forEach((oBay) => {
                    if (!bayLevelCgsInfo[oBay])
                        bayLevelCgsInfo[oBay] = {};
                    const bayLevelVcgsInfoOfBay = bayLevelCgsInfo[oBay];
                    if (!bayLevelVcgsInfoOfBay[level]) {
                        const positions = new Set();
                        positions.add(c.position);
                        bayLevelVcgsInfoOfBay[level] = {
                            bottomBase: clonedCellInfoBySize.bottomBase || 0,
                            bottomTier: c.tier,
                            maxHeight: 0,
                            portTcg,
                            starboardTcg: stbdTcg,
                            maxForeLcg: lcgsBy20Bay[oBay].maxForeLcg,
                            minAftLcg: lcgsBy20Bay[oBay].minAftLcg,
                            positions,
                        };
                    }
                    else {
                        bayLevelVcgsInfoOfBay[level].positions.add(c.position);
                        if (bayLevelVcgsInfoOfBay[level].portTcg > portTcg)
                            bayLevelVcgsInfoOfBay[level].portTcg = portTcg;
                        if (bayLevelVcgsInfoOfBay[level].starboardTcg < stbdTcg)
                            bayLevelVcgsInfoOfBay[level].starboardTcg = stbdTcg;
                    }
                });
            }); // End of contsInRowFromBottomToTop.forEach
        }); // End of rows allRowsInShip.forEach
        // 2nd pass to define the heights and bottom bases once all the containers are stacked
        const oddBaysToDefine = new Set([bay]);
        if (pairedBay)
            oddBaysToDefine.add(pairedBay);
        const { allContainersCgsOfRow, lowestBottomBaseOfRow } = getAllContainerCgsInTheRow(oddBaysToDefine, level);
        oddBaysToDefine.forEach((oBay) => {
            var _a;
            const bayLevelVcgsInfoOfBay = bayLevelCgsInfo[oBay];
            if (!(bayLevelVcgsInfoOfBay === null || bayLevelVcgsInfoOfBay === void 0 ? void 0 : bayLevelVcgsInfoOfBay[level]))
                return;
            let prevTier = (_a = allContainersCgsOfRow[0].meta) === null || _a === void 0 ? void 0 : _a.tier;
            let addedUpHeight = 0;
            let lastHeight = 0;
            allContainersCgsOfRow.forEach((c) => {
                if (!c.meta)
                    return;
                if (c.meta.tier !== prevTier) {
                    addedUpHeight += c.meta.height || 0;
                    prevTier = c.meta.tier;
                }
                c.tierBottomBase = addedUpHeight + lowestBottomBaseOfRow;
                lastHeight = c.meta.height || 0;
            });
            bayLevelVcgsInfoOfBay[level].bottomBase = lowestBottomBaseOfRow || 0;
            bayLevelVcgsInfoOfBay[level].maxHeight = addedUpHeight + lastHeight;
            if (bayLevelVcgsInfoOfBay[level].maxHeight > maxHeight)
                maxHeight = bayLevelVcgsInfoOfBay[level].maxHeight;
            if (shipMaxHeight < maxHeight + lowestBottomBaseOfRow)
                shipMaxHeight = maxHeight + lowestBottomBaseOfRow;
        });
    });
    return {
        missingImportantLcgs,
        missingImportantVcgs,
        missingImportantTcgs,
        containersCgsByPosition,
        containersCgsArray,
        containerCgsByBayAndLevelAndRow: containerCgsByPairedBaysAndLevelAndRow,
        bayLevelCgsInfo,
        maxHeightAbsolute: shipMaxHeight,
    };
    function getAllContainerCgsInTheRow(oddBaysToDefine, level) {
        let lowestBottomBaseOfRow = Infinity;
        const allContainersCgsOfRow = new Set();
        oddBaysToDefine.forEach((bay) => {
            const bayLevelVcgsInfoOfBay = bayLevelCgsInfo[bay];
            if (!(bayLevelVcgsInfoOfBay === null || bayLevelVcgsInfoOfBay === void 0 ? void 0 : bayLevelVcgsInfoOfBay[level]))
                return;
            bayLevelVcgsInfoOfBay[level].positions.forEach((pos) => {
                var _a;
                const posCgs = containersCgsByPosition[pos];
                const row = (_a = posCgs === null || posCgs === void 0 ? void 0 : posCgs.meta) === null || _a === void 0 ? void 0 : _a.row;
                if (posCgs === undefined ||
                    row === undefined ||
                    posCgs.bottomBase === undefined)
                    return;
                allContainersCgsOfRow.add(posCgs);
                if (lowestBottomBaseOfRow > posCgs.bottomBase) {
                    lowestBottomBaseOfRow = posCgs.bottomBase;
                }
            });
        });
        return {
            allContainersCgsOfRow: Array.from(allContainersCgsOfRow).sort((a, b) => { var _a, _b; return (Number((_a = a.meta) === null || _a === void 0 ? void 0 : _a.tier) || 0) - (Number((_b = b.meta) === null || _b === void 0 ? void 0 : _b.tier) || 0); }),
            lowestBottomBaseOfRow,
        };
    }
}
/** String sort is enough because positions {BAY}{ROW}{TIER} share {BAY}{ROW} and the Tier (asc) is what we want */
function sortPositionByTierAsc(a, b) {
    const tierA = a.position.substring(5);
    const tierB = b.position.substring(5);
    return Number(tierA) - Number(tierB);
}
